import * as React from "react";
import "./styles.scss";
import {
    Actions,
    CensusEquipmentStatusDetailsEnum,
    CensusEquipmentStatusesEnum
} from "../../../processes/massive_actions/CensusCooler/data/models/CensusEnums";
import {Display} from "../../../components/Display";
import {StatusInfo} from "../../../processes/massive_actions/CensusCooler/components/StatusDescriptionTooltip";

interface SuggestedAndFinalActionAccordionHeaderProps {
    statusIcon: CensusEquipmentStatusesEnum;
    headerName: string;
    equipmentCount: number;
    isOpen: boolean;
    translatedActionsEnum: Actions;
    onClick: (name: string) => void;
    status: CensusEquipmentStatusesEnum;
    statusDetail?: CensusEquipmentStatusDetailsEnum;
    level?: number;
    containsEditedActions?: boolean;
    description: string
}

const getStatusIcon = (status: CensusEquipmentStatusesEnum) => {
    let iconName = "";
    let className = "";
    switch (status) {
        case CensusEquipmentStatusesEnum.FAIL:
            iconName = "cancel";
            className = "icon-error";
            break;
        case CensusEquipmentStatusesEnum.WARNING:
            iconName = "warning";
            className = "icon-warning";
            break;
        case CensusEquipmentStatusesEnum.OK:
            iconName = "check_circle";
            className = "icon-success";
            break;
    }
    return (
        <span className={`material-symbols-outlined status-icon ${className}`}>
			{iconName}
		</span>
    );
};

export const SuggestedAndFinalActionAccordionHeader: React.FC<
    SuggestedAndFinalActionAccordionHeaderProps
> = ({
         statusIcon,
         headerName,
         equipmentCount,
         isOpen,
         level,
         onClick,
         containsEditedActions,
         description,
     }) => {
    const handleOnClick = () => {
        onClick(headerName);
    };
    return (
        <div
            className={`header-far-item first-level  ${level === 0 ? "header-with-icon" : "header-no-icon"} ${containsEditedActions ? "edited" : ""}`}
            onClick={handleOnClick}
        >
			<span
                className={`material-symbols-outlined chevron-icon ${isOpen ? "chevron-down" : ""}`}
            >
				chevron_right
			</span>
            <Display isVisible={level === 0}>{getStatusIcon(statusIcon)}</Display>
            <span className={`header-far-item__title ${containsEditedActions ? "edited" : ""}`}>
				{headerName + " (" + equipmentCount + ")"}
			</span>
            <div className={"info-icon"}>
                <StatusInfo description={description}/>
            </div>
        </div>
    );
};
